const LOCAL_STORAGE_KEYS = {
  token: "token",
  admin: "admin",
  lang:"lang",
};

export function setToken(value) {
  localStorage.setItem(LOCAL_STORAGE_KEYS.token, value);
}

export function clearToken() {
  localStorage.removeItem(LOCAL_STORAGE_KEYS.token);
}

export function getToken() {
  try {
    return localStorage.getItem(LOCAL_STORAGE_KEYS.token);
  } catch (err) {
    clearToken();
    return null;
  }
}

export function setAdmin(value) {
  localStorage.setItem(LOCAL_STORAGE_KEYS.admin, value);
}

export function clearAdmin(value) {
  localStorage.removeItem(LOCAL_STORAGE_KEYS.admin, value);
}

export function getAdmin() {
  try {
    return localStorage.getItem(LOCAL_STORAGE_KEYS.admin);
  } catch (err) {
    clearAdmin();
    return null;
  }
}

export function setStoreLang(value) {
  // Ensure it's stored as a JSON array
  localStorage.setItem(LOCAL_STORAGE_KEYS.lang, JSON.stringify(value));
}

export function getStoreLang() {
  try {
    const data = localStorage.getItem(LOCAL_STORAGE_KEYS.lang);
    return data ? JSON.parse(data) : []; // Return an array, not a string
  } catch (err) {
    clearAdmin();
    return [];
  }
}
